<template>
	<v-dialog
			v-model="show"
			content-class="rounded-xl"
			persistent
			scrollable
			width="600px"
	>
		<v-card class="position-relative" rounded="xl">
			<v-card-title class="d-flex justify-space-between ma-0 ma-md-4">
				<div class="w-100">
					<div class="align-center d-flex justify-space-between">
						<h6>{{ title }}</h6>
					</div>
				</div>
			</v-card-title>
			<v-card-text class="text-body-2">
				<v-row>
					<v-col><span v-html="description"></span></v-col>
				</v-row>
			</v-card-text>
			<v-card-actions>
				<div class="align-center d-flex justify-space-between w-100">
					<div v-if="!dismissable" class="d-flex justify-end">
						<v-btn
								class="me-2 me-md-4 rounded-lg"
								color="grey darken-1"
								depressed
								:large="$vuetify.breakpoint.mdAndUp"
								outlined
								@click="() => $emit('cancel')"
						>
							{{ cancelText }}
						</v-btn>
						<v-btn
								class="rounded-lg"
								color="primary"
								depressed
								:large="$vuetify.breakpoint.mdAndUp"
								@click="() => $emit('confirm')"
						>
							{{ confirmText }}
						</v-btn>
					</div>
					<div v-else style="margin: auto">
						<v-btn
								class="rounded-lg"
								color="primary"
								depressed
								:large="$vuetify.breakpoint.mdAndUp"
								@click="() => $emit('dismiss')"
						>
							{{ dismissText }}
						</v-btn>
					</div>
				</div>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'ConfirmDialog',
	props: {
		cancelText: {
			type: String,
			default: 'Cancel'
		},
		confirmText: {
			type: String,
			default: 'Confirm'
		},
		description: {
			type: String,
			default: 'Are you sure? This can\'t be undone'
		},
		dismissable: {
			type: Boolean,
			default: false
		},
		dismissText: {
			type: String,
			default: 'Dismiss'
		},
		open: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: 'Confirmation'
		}
	},
	data() {
		return {
			show: false
		};
	},
	mounted() {
		this.show = this.open;
	},
	watch: {
		open(newValue) {
			this.show = newValue;
		}
	}
}
</script>
